import React from 'react';
import NewsImage from '../NewsImage';

const NewsContent = ({
  news,
  onTagClick,
}) => {
  return (
    <div className="single-news-content">
      {news.image && (
        <NewsImage
          news={news}
          alt={news.title}
          className="floating-news-image"
          loading="eager"
        />
      )}

      <div
        dangerouslySetInnerHTML={{
          __html: news.content,
        }}
      />

      {Array.isArray(news.tags) &&
        news.tags.length > 0 && (
          <div className="news-tags-block">
            <div className="news-tags">
              {news.tags.map(
                (tag, index) => (
                  <button
                    key={`${tag}-${index}`}
                    className="news-tag"
                    onClick={() =>
                      onTagClick(tag)
                    }
                    type="button"
                  >
                    #{tag}
                  </button>
                )
              )}
            </div>
          </div>
        )}
    </div>
  );
};

export default NewsContent;
